(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["r-header"] && !Shopify.designMode) return;
  try {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setAnnouncementBarHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setAnnouncementBarHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    setAnnouncementBarHeight() {
      if (this.announcementBar) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.announcementBar.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.announcementBar.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= 1) {
        this.header.classList.remove('scrolled-past-header');
        this.announcementBar.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.announcementBar.classList.add('shopify-section-announcement-bar-section-hidden', 'announcement-bar-section-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.announcementBar.classList.add('announcement-bar-section-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.announcementBar.classList.remove('shopify-section-announcement-bar-section-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.announcementBar.classList.remove('shopify-section-announcement-bar-section-hidden', 'announcement-bar-section-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) 
        this.searchModal.close(false);
      
    }
  }

  customElements.define('sticky-header', StickyHeader);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sale-countdown-timer"] && !Shopify.designMode) return;
  try {
    class SaleCountdownTimer {
    constructor(element) {
      this.element = element;
      this.hoursDisplay = element.querySelector('[data-hours]');
      this.minutesDisplay = element.querySelector('[data-minutes]');
      this.secondsDisplay = element.querySelector('[data-seconds]');

      // Get default values from data attributes (starting time from theme settings)
      this.defaultHours = parseInt(element.dataset.defaultHours) || 0;
      this.defaultMinutes = parseInt(element.dataset.defaultMinutes) || 0;
      this.defaultSeconds = parseInt(element.dataset.defaultSeconds) || 0;

      this.storageKey = `countdown_timer_${window.location.hostname}_global`;
      this.interval = null;
      this.storageAvailable = this.checkStorageAvailability();

      this.init();
    }

    // Check if localStorage is available (handles private browsing mode)
    checkStorageAvailability() {
      try {
        const test = '__storage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch (e) {
        console.warn('localStorage unavailable, timer will reset on page refresh');
        return false;
      }
    }

    init() {
      try {
        // Check if we have a stored end time in localStorage
        const storedEndTime = this.storageAvailable ? localStorage.getItem(this.storageKey) : null;

        if (storedEndTime) {
          this.endTime = parseInt(storedEndTime);
        } else {
          // Calculate end time based on default starting time from theme settings
          const totalSeconds = (this.defaultHours * 3600) + (this.defaultMinutes * 60) + this.defaultSeconds;
          this.endTime = Date.now() + (totalSeconds * 1000);

          if (this.storageAvailable) {
            localStorage.setItem(this.storageKey, this.endTime);
          }
        }

        this.updateDisplay();
        this.startTimer();
      } catch (e) {
        console.error('Error initializing countdown timer:', e);
        // Fallback: calculate end time without storage
        const totalSeconds = (this.defaultHours * 3600) + (this.defaultMinutes * 60) + this.defaultSeconds;
        this.endTime = Date.now() + (totalSeconds * 1000);
        this.updateDisplay();
        this.startTimer();
      }
    }

    startTimer() {
      this.interval = setInterval(() => {
        this.updateDisplay();
      }, 1000);
    }

    updateDisplay() {
      const now = Date.now();
      const distance = this.endTime - now;

      if (distance <= 0) {
        // Timer has ended - display 00:00:00 and stay there (don't hide or restart)
        this.hoursDisplay.textContent = '00';
        this.minutesDisplay.textContent = '00';
        this.secondsDisplay.textContent = '00';

        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
        return;
      }

      // Calculate time remaining
      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Update display with zero padding
      this.hoursDisplay.textContent = String(hours).padStart(2, '0');
      this.minutesDisplay.textContent = String(minutes).padStart(2, '0');
      this.secondsDisplay.textContent = String(seconds).padStart(2, '0');
    }

    // Method to reset timer (useful for testing or theme editor)
    reset() {
      try {
        if (this.storageAvailable) {
          localStorage.removeItem(this.storageKey);
        }
      } catch (e) {
        console.warn('Could not clear localStorage:', e);
      }

      if (this.interval) {
        clearInterval(this.interval);
      }
      this.init();
    }

    // Cleanup method to prevent memory leaks
    destroy() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
  }

  // Initialize global timer instance storage
  if (!window.countdownTimers) {
    window.countdownTimers = [];
  }

  // Initialize all countdown timers on the page
  document.addEventListener('DOMContentLoaded', () => {
    const timers = document.querySelectorAll('[data-sale-counter-timer]');
    timers.forEach((timer, index) => {
      const countdownTimer = new SaleCountdownTimer(timer);
      window.countdownTimers[index] = countdownTimer;
    });
  });

  // Global reset function for theme editor preview and testing
  window.resetSaleCountdownTimer = (index = 0) => {
    if (window.countdownTimers && window.countdownTimers[index]) {
      window.countdownTimers[index].reset();
    }
  };

  // Global reset all function
  window.resetAllSaleCountdownTimers = () => {
    if (window.countdownTimers) {
      window.countdownTimers.forEach(timer => {
        if (timer) timer.reset();
      });
    }
  };

  // Global cleanup function to prevent memory leaks
  window.destroySaleCountdownTimers = () => {
    if (window.countdownTimers) {
      window.countdownTimers.forEach(timer => {
        if (timer) timer.destroy();
      });
      window.countdownTimers = [];
    }
  };

  // Reinitialize on Shopify theme editor changes
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const timer = event.target.querySelector('[data-sale-counter-timer]');
      if (timer) {
        const countdownTimer = new SaleCountdownTimer(timer);
        window.countdownTimers.push(countdownTimer);
      }
    });

    // Cleanup on section unload
    document.addEventListener('shopify:section:unload', (event) => {
      const timer = event.target.querySelector('[data-sale-counter-timer]');
      if (timer) {
        // Find and destroy the corresponding timer instance
        const index = window.countdownTimers.findIndex(t => t && t.element === timer);
        if (index !== -1 && window.countdownTimers[index]) {
          window.countdownTimers[index].destroy();
          window.countdownTimers.splice(index, 1);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-selector-widget"] && !Shopify.designMode) return;
  try {
    // Which item is selected in the variant switcher, 1st, 2nd, or 3rd.
  let globalState = [];

  function initVariantSelector(variantSelectorId, productHandle, flavorSelectorOnly) {
    globalState[variantSelectorId] = {
      selectedItem: null,
      selectedBundle: null,
    };

    const allVariantSelectorSections = document.querySelectorAll(
      `.js-VariantSelectorSectionContent[data-variant-selector-id="${variantSelectorId}"]`
    );

    allVariantSelectorSections.forEach((tempSection, index) => {
      if (index !== 0) {
        // Temp fix because the CSS solution isn't working for some reason with multiple
        tempSection.parentNode.style.display = 'none';
      }
    });

    // Bundle selector logic
    const bundleSelectorItems = document.querySelectorAll(
      `.js-VariantSelectorSectionContent[data-variant-selector-id="${variantSelectorId}"] .js-BundleSelectorItem`
    );

    if (bundleSelectorItems) {
      bundleSelectorItems.forEach((bundleSelectorItem) => {
        bundleSelectorItem.addEventListener('click', (e) => {
          e.preventDefault();

          // Hide all
          allVariantSelectorSections.forEach((variantSelectorSection) => {
            variantSelectorSection.parentNode.style.display = 'none';
          });

          const bundleSelectorId = bundleSelectorItem.dataset.bundleSelectorId;

          globalState[variantSelectorId].selectedBundle = bundleSelectorItem.dataset.bundle;

          console.log('Unit203 hello: ', globalState[variantSelectorId]);

          let clickedSectionContentParent = null;

          if (flavorSelectorOnly) {
            // Get the clicked section parent so we can display it
            clickedSectionContentParent = document.querySelector(
              `.js-VariantSelectorSectionContent[data-variant-selector-id="${variantSelectorId}"][data-variant-selector-product-handle="${bundleSelectorId}"]`
            ).parentNode;
          } else {
            if (
              globalState[variantSelectorId].selectedItem !== null &&
              globalState[variantSelectorId].selectedBundle !== null
            ) {
              console.log('noooo way its here!');
              // Get the clicked section parent so we can display it
              clickedSectionContentParent = document.querySelector(
                `.js-VariantSelectorSectionContent[data-variant-selector-id="${variantSelectorId}"][data-selected-variant-item="${globalState[variantSelectorId].selectedItem}"][data-bundle-selector-id="${globalState[variantSelectorId].selectedBundle}"]`
              ).parentNode;
            } else {
              console.log('we get the error here!!!!!!!');
              // Get the clicked section parent so we can display it
              clickedSectionContentParent = document.querySelector(
                `.js-VariantSelectorSectionContent[data-variant-selector-id="${variantSelectorId}"][data-variant-selector-product-handle="${bundleSelectorId}"]`
              ).parentNode;
            }
          }

          clickedSectionContentParent.style.display = 'block';
        });
      });
    }

    // Variant selector logic
    const variantSelectorWidgetContainer = document.querySelector(
      `.js-VariantSelectorWidget[data-variant-selector-id="${variantSelectorId}"][data-variant-selector-product-handle="${productHandle}"]`
    );

    if (variantSelectorWidgetContainer) {
      const variantClickableItems = variantSelectorWidgetContainer.querySelectorAll('.js-VariantSelectorClickableItem');

      if (variantClickableItems) {
        variantClickableItems.forEach((clickableItem) => {
          const clickableItemProductHandle = clickableItem.dataset.variantSelectorProductHandle;

          clickableItem.addEventListener('click', (e) => {
            e.preventDefault();

            globalState[variantSelectorId].selectedItem = clickableItem.dataset.variantSelectorActiveProductIdentifier;
            globalState[variantSelectorId].selectedBundle = clickableItem.dataset.bundleSelectorId;

            console.log('Unit203 hello: ', globalState[variantSelectorId]);

            const clickedSectionContentParent = document.querySelector(
              `.js-VariantSelectorSectionContent[data-variant-selector-id="${variantSelectorId}"][data-variant-selector-product-handle="${clickableItemProductHandle}"]`
            ).parentNode;

            // Set all sections to hide except the one we clicked
            allVariantSelectorSections.forEach((variantSelectorSection) => {
              variantSelectorSection.parentNode.style.display = 'none';
            });

            clickedSectionContentParent.style.display = 'block';
          });
        });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const variantSelectorWidgetContainers = document.querySelectorAll(`.js-VariantSelectorWidget`);

    if (variantSelectorWidgetContainers) {
      variantSelectorWidgetContainers.forEach((variantSelectorWidgetContainer) => {
        const variantSelectorId = variantSelectorWidgetContainer.dataset.variantSelectorId;
        const productHandle = variantSelectorWidgetContainer.dataset.variantSelectorProductHandle;
        const flavorSelectorOnly = variantSelectorWidgetContainer.dataset.flavorSelectorOnly;
        initVariantSelector(variantSelectorId, productHandle, flavorSelectorOnly);
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
